import { useLocation } from "@tanstack/react-router"
import { Link } from "@/src/components/core/components/links/Link"
import { NavigationAdminMenu } from "../NavigationAdminMenu"
import { NavigationGeneralLogo } from "../NavigationLoggedOut/TrassenscoutLogo"
import { NavigationMetaMenu } from "../NavigationMetaMenu"
import { NavigationUser } from "../NavigationUser/NavigationUser"
import { NavigationUserLoggedOut } from "../NavigationUser/NavigationUserLoggedOut"
import { NavigationUserPublic } from "../NavigationUser/NavigationUserPublic"
import type { NavigationUserVariant } from "../types"

type Props = {
  homeLink: string
  homeLinkText: string
  children?: React.ReactNode
  /** Round icon actions, left of the admin, meta, and user menus. */
  actions?: React.ReactNode
  userVariant?: NavigationUserVariant
}

export const NavigationDesktop = ({
  homeLink,
  homeLinkText,
  children,
  actions,
  userVariant = "auto",
}: Props) => {
  const pathname = useLocation().pathname

  return (
    <div className="relative hidden nav:flex nav:flex-row nav:items-center nav:justify-between">
      <div className="relative flex min-h-16 min-w-0 items-center justify-between gap-4 nav:h-16">
        <div className="flex shrink-0 items-center justify-start nav:items-stretch">
          <div className="flex shrink-0 items-center justify-center">
            {pathname === homeLink ? (
              <NavigationGeneralLogo beta={false} />
            ) : (
              <Link to={homeLink}>
                <NavigationGeneralLogo beta={false} />
                <span className="sr-only">{homeLinkText}</span>
              </Link>
            )}
          </div>
        </div>

        {children}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        {userVariant === "loggedOut" ? (
          <NavigationUserLoggedOut />
        ) : userVariant === "public" ? (
          <NavigationUserPublic />
        ) : (
          <>
            <NavigationAdminMenu />
            <NavigationMetaMenu />
            <NavigationUser />
          </>
        )}
      </div>
    </div>
  )
}
